import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';
import Select from "react-select";

import { SelectOptionsHelper } from '../../helpers/SelectOptionsHelper';
import { LoadingSpinner } from '../../LoadingSpinner';

export class FareProductsForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model,
            nameInputError: null,
            stateInputError: null,
            fareInputError: null,
            currencyInputError: null,
        }
    }

    // -----------------

    onChangeValue(e, property) {
        const { model } = this.state;

        model[property] = e.target.value;

        this.setState({
            model: model
        });
    }

    onSelectValue(e, property) {
        const { model } = this.state;

        model[property] = e;

        this.setState({
            model: model
        });
    }

    onSave() {
        if (this.validInput()) {
            const { model } = this.state;
            this.props.onSave(model);
        }
    }

    validInput() {
        let errors = 0;
        let nameInputError = null;
        let stateInputError = null;
        let fareInputError = null;
        let currencyInputError = null;

        const { model } = this.state;

        if ("" === model.name || null === model.name || undefined === model.name) {
            nameInputError = 'error';
            errors++;
        }

        if ("" === model.state || null === model.state || undefined === model.state) {
            stateInputError = 'error';
            errors++;
        }

        if ("" === model.fare || null === model.fare || undefined === model.fare || 0 === model.fare.id || "0" === model.fare.id) {
            fareInputError = 'error';
            errors++;
        }

        if ("" === model.currencyId || null === model.currencyId || undefined === model.currencyId || 0 === model.currencyId || "0" === model.currencyId) {
            currencyInputError = 'error';
            errors++;
        }

        this.setState({
            nameInputError: nameInputError,
            stateInputError: stateInputError,
            fareInputError: fareInputError,
            currencyInputError: currencyInputError,
        });

        return 0 === errors;
    }

    // -------------------

    renderModalBody(isLoadingDependencies, model) {
        if (isLoadingDependencies) {
            return (<LoadingSpinner />);
        }

        const { currencies, fares, regions } = this.props;
        const { nameInputError, stateInputError, fareInputError, currencyInputError } = this.state;

        return (
            <div>
                <Form>
                    <FormGroup controlId="formName" validationState={nameInputError}>
                        <ControlLabel>Nome</ControlLabel>
                        <FormControl
                            type="text"
                            value={model.name}
                            placeholder="Nome"
                            onChange={(e) => this.onChangeValue(e, "name")} />

                        {nameInputError !== null ?
                            <HelpBlock> Este campo não pode estar vazio.</HelpBlock> :
                            null}
                    </FormGroup>

                    <FormGroup controlId="formState" validationState={stateInputError}>
                        <ControlLabel>Estado</ControlLabel>
                        <Select
                            className="custom-multiselect"
                            placeholder="Selecione o Estado"
                            onChange={(e) => this.onSelectValue(null === e ? undefined : e.value, "state")}
                            options={SelectOptionsHelper.FareProductState}
                            isMulti={false}
                            isOptionSelected={function (a) {
                                return a.value === model.state;
                            }}
                            getOptionValue={value => value}
                            getOptionLabel={label => label.label}
                            value={SelectOptionsHelper.FareProductState.find(state => state.value === model.state)} />

                        {stateInputError !== null ?
                            <HelpBlock> Este campo não pode estar vazio.</HelpBlock> :
                            null}
                    </FormGroup>

                    <FormGroup controlId="formLineRegions">
                        <ControlLabel>Regiões</ControlLabel>
                        <Select
                            className="custom-multiselect"
                            placeholder="Selecione as Regiões"
                            noOptionsMessage={() => "Sem Regiões Configuradas"}
                            onChange={(e) => this.onSelectValue(e, "regions")}
                            options={regions}
                            isMulti={true}
                            isOptionSelected={function (a) {
                                if (Array.isArray(model.regions)) {
                                    return model.regions.includes(a);
                                }
                            }}
                            getOptionValue={value => value}
                            getOptionLabel={label => label.name}
                            value={model.regions}
                        />
                    </FormGroup>

                    <FormGroup controlId="formFare" validationState={fareInputError}>
                        <ControlLabel>Tipo de Tarifário</ControlLabel>
                        <Select
                            className="custom-multiselect"
                            placeholder="Selecione o Tipo de Tarifário"
                            onChange={(e) => this.onSelectValue(e, "fare")}
                            options={fares}
                            isMulti={false}
                            isOptionSelected={function (a) {
                                if (undefined !== model.fare) {
                                    return a.id === model.fare.id;
                                }
                            }}
                            getOptionValue={value => value}
                            getOptionLabel={label => label.name}
                            value={model.fare} />

                        {fareInputError !== null ?
                            <HelpBlock> Este campo não pode estar vazio.</HelpBlock> :
                            null}
                    </FormGroup>

                    <FormGroup controlId="formCurrency" validationState={currencyInputError}>
                        <ControlLabel>Moeda</ControlLabel>
                        <Select
                            className="custom-multiselect"
                            placeholder="Selecione a Moeda"
                            onChange={(e) => this.onSelectValue(null === e ? undefined : e.id, "currencyId")}
                            options={currencies}
                            isMulti={false}
                            isOptionSelected={function (a) {
                                return a.id === model.currencyId;
                            }}
                            getOptionValue={value => value}
                            getOptionLabel={label => label.name}
                            value={currencies.find(currency => currency.id === model.currencyId)} />

                        {currencyInputError !== null ?
                            <HelpBlock> Este campo não pode estar vazio.</HelpBlock> :
                            null}
                    </FormGroup>
                </Form>
                <ButtonToolbar>
                    <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                    <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                </ButtonToolbar>
            </div>
        );
    }

    render() {
        const { model } = this.state;

        if (undefined === model || null === model) {
            return null;
        }

        const { title, isLoadingDependencies } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.renderModalBody(isLoadingDependencies, model)}
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/fareProducts/FareProductsForm.js